import { createApiClient } from "@pushup/shared";
import { env } from "./env";

/**
 * Include cookies on every request so the Better Auth session cookie is sent
 * with the admin API calls.
 */
export const WITH_CREDENTIALS = { credentials: "include" } as const;

export const api = createApiClient({ baseUrl: env.VITE_API_BASE_URL });
